import { render } from "./AdminLeftNav.vue?vue&type=template&id=22896430"
import script from "./AdminLeftNav.vue?vue&type=script&lang=js"
export * from "./AdminLeftNav.vue?vue&type=script&lang=js"

import "./AdminLeftNav.vue?vue&type=style&index=0&id=22896430&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__